var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import InputError from '@/container/Ui/Common/InputError';
import PlainInput from '@/container/Ui/Common/PlainInput';
import { propShape } from '@/helpers/custom-prop-types';
const FieldName = (props) => {
    const { first_name: { input: firstNameInput, meta: firstNameMeta }, last_name: { input: lastNameInput, meta: lastNameMeta }, } = props;
    const { value: firstNameValue } = firstNameInput, firstNameOtherInput = __rest(firstNameInput, ["value"]);
    const { value: lastNameValue } = lastNameInput, lastNameOtherInput = __rest(lastNameInput, ["value"]);
    const metas = useMemo(() => [lastNameMeta, firstNameMeta], [lastNameMeta, firstNameMeta]);
    return (_jsxs("div", { children: [_jsx("h5", Object.assign({ className: 'consultation_information_label' }, { children: "\u6C0F\u540D" })), _jsxs("div", Object.assign({ className: 'consultation_information_name' }, { children: [_jsx(PlainInput, { className: 'input_text', defaultValue: lastNameValue, id: lastNameOtherInput.name, input: lastNameOtherInput, meta: lastNameMeta, placeholder: '姓' }), _jsx(PlainInput, { className: 'input_text', defaultValue: firstNameValue, id: firstNameOtherInput.name, input: firstNameOtherInput, meta: firstNameMeta, placeholder: '名' })] })), _jsx(InputError, { metas: metas })] }));
};
FieldName.propTypes = {
    first_name: propShape().isRequired,
    last_name: propShape().isRequired,
};
export default FieldName;
